import { companyConstants } from "../constants";

export const company = (state = {}, action) => {
    switch (action.type) {
        case companyConstants.GETALL_COMPANYSETTINGS_REQUEST:
            return {
                ...state,
            };
        case companyConstants.GETALL_COMPANYSETTINGS_SUCCESS:
            return {
                ...state,
                companySettings: action.companySettings,
            };
        case companyConstants.GETALL_COMPANYSETTINGS_FAILURE:
            return {
                ...state,
                error: action.error,
            };
        case companyConstants.UPDATECOMPANYSETTINGS_REQUEST:
            return {
                ...state,
            };
        case companyConstants.UPDATECOMPANYSETTINGS_SUCCESS:
            return {
                ...state,
                companySettings: action.companySettings,
            };
        case companyConstants.UPDATECOMPANYSETTINGS_FAILURE:
            return {
                ...state,
                error: action.error,
            };
        default:
            return state;
    }
};